import React, { useEffect, useState } from 'react'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'

import { connect, Actions, Selectors } from '@react-page/core/lib'
import { focus } from '@react-page/core/lib/selector/focus'

import ContentBlockSave from '../ContentBlockSave'

import * as S from './styled'

const Inner = ({
    id,
    searchNodeEverywhere,
    updateCellContent,
    updateCellLayout,
    editor,
    getLibraryBlocks,
    ...props
}) => {
    const result = searchNodeEverywhere(id)

    if (!result) {
        return (
            <p className="!p-4 !text-center">
                You are in Edit mode.
                <br />
                Click the page element that you would like to edit.
            </p>
        )
    }

    const {
        node: {
            rows = [],
            layout: {
                plugin: {
                    Component: LayoutComponent = undefined,
                    config: layoutConfig = undefined,
                    name: layoutType = undefined,
                    text: layoutTitle = undefined,
                } = {},
                state: layoutState = {},
            } = {},
            content: {
                plugin: {
                    Component: ContentComponent = undefined,
                    config: contentConfig = undefined,
                    name: contentType = undefined,
                    text: contentTitle = undefined,
                } = {},
                state: contentState = {},
            } = {},
        },
    } = result

    if (rows.length && LayoutComponent) {
        const { FormComponent = null, DecoratedForm = null } = layoutConfig

        const props = {
            id,
            config: layoutConfig,
            state: layoutState,
            onChange: updateCellLayout,
        }

        return (
            <S.FormWrapper>
                <h3 className="!uppercase !mb-2">{layoutTitle}</h3>
                {FormComponent ? <FormComponent {...props} /> : ''}
                {DecoratedForm && <DecoratedForm {...props} />}
                <hr />
                <ContentBlockSave {...result} getLibraryBlocks={getLibraryBlocks} editor={editor} />
            </S.FormWrapper>
        )
    } else if (ContentComponent) {
        const { FormComponent = null, DecoratedForm = null } = contentConfig

        const props = {
            id,
            config: contentConfig,
            state: contentState,
            onChange: updateCellContent,
        }

        return (
            <S.FormWrapper>
                <h3 className="!uppercase !mb-2">{contentTitle}</h3>
                {FormComponent ? <FormComponent {...props} /> : null}
                {DecoratedForm && <DecoratedForm {...props} />}
            </S.FormWrapper>
        )
    }

    return <S.FormWrapper>Whoops</S.FormWrapper>
}

const mapStateToProps = createStructuredSelector({
    searchNodeEverywhere: state => id => Selectors.Editable.searchNodeEverywhere(state, id),
})

const mapDispatchToProps = (dispatch, { id }) => {
    return bindActionCreators(
        {
            updateCellContent: Actions.Cell.updateCellContent(id),
            updateCellLayout: Actions.Cell.updateCellLayout(id),
        },
        dispatch
    )
}

const ConnectedInner = connect(mapStateToProps, mapDispatchToProps)(Inner)

const EditForm = ({ focus, editor, ...props }) => {
    const [id, setId] = useState()

    useEffect(() => {
        if (focus && focus !== id) {
            setId(focus)
        }
    }, [focus])

    return <ConnectedInner id={id} editor={editor} {...props} />
}

export default connect(
    createStructuredSelector({
        focus,
    }),
    {}
)(EditForm)
